import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const orderCardStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    backgroundColor: tokens.colorNeutralBackground1,
    height: "100vh",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "stretch",
    ...shorthands.padding("24px", "0px", "20px", "0px"),
    ...shorthands.gap("6px"),
    backgroundColor: tokens.colorNeutralBackground1,
    "@media (min-width: 500px)": {
      height: "100%",
      alignItems: "stretch",
      backgroundColor: tokens.colorNeutralBackground2,
    },
  },
  subMainContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("12px"),
    "@media (min-width: 500px)": {
      ...shorthands.padding("24px"),
      ...shorthands.borderRadius("8px"),
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: tokens.shadow2,
      height: "100vh",
      ...shorthands.overflow("hidden"),
    },
    "@media (min-width: 500px) and (max-width: 899px)": {
      marginLeft: "40px",
      marginRight: "40px",
      maxWidth: "100%",
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      ...shorthands.margin("0px", "auto"),
      width: "840px",
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginLeft: "200px",
      marginRight: "200px",
      maxWidth: "100%",
    },
    "@media (min-width: 1400px)": {
      ...shorthands.margin("0px", "auto"),
      width: "1040px",
    },
  },
  orderDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("0px", "0px", "20px", "0px"),
    ...shorthands.gap("20px"),
    rowGap: "20px",
  },
  orderDetails: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  orderLeftAlignment: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("20px"),
    width: "100%",
  },

  title: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase500,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase500,
    width: "100%",
  },
  orderDate: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground4,
  },
  rightAlignment: {
    textAlign: "right",
    display: "block",
  },
  rightAlignmentButton: {
    display: "flex",
    width: "207px",
    height: "40px",
    ...shorthands.padding("8px", "16px", "8px", "16px"),
    backgroundColor: tokens.colorBrandForeground1,
    color: tokens.colorNeutralForegroundOnBrand,
    "&:disabled": {
      backgroundColor: tokens.colorNeutralBackgroundDisabled,
      color: tokens.colorNeutralForegroundDisabled,
      "&:hover": {
        backgroundColor: tokens.colorNeutralBackgroundDisabled,
        color: tokens.colorNeutralForegroundDisabled,
      },
    },
    "&:hover": {
      backgroundColor: "#5432E6",
      color: tokens.colorNeutralForegroundOnBrand,
    },
  },
  reorderButtonContainer: {
    display: "block",
    rowGap: "8px",
  },
  reorderButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "10px",
    alignContent: "center",
  },
  order: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  subTitle: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
  },
  orderSummaryContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("0px"),
    ...shorthands.gap("20px"),
    ...shorthands.overflow("hidden"),
    height: "100%",
  },
  orderSummary: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("24px", "24px", "36px", "24px"),
    backgroundColor: tokens.colorNeutralBackground2,
    ...shorthands.borderRadius("8px"),
    "@media (min-width: 500px)": {
      ...shorthands.overflow("hidden"),
      scrollbarGutter: "stable",
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "#ccc",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
      },
      "&:hover": {
        overflowY: "auto",
      },
    },
  },
  itemList: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  cardEntry: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    ...shorthands.gap("12px"),
    ">div": {
      ...shorthands.padding("12px", "0px", "12px", "0px"),
      minHeight: "0px",
    },
  },
  itemAmount: {
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3,
  },
  amountBody: {
    flexDirection: "row",
    alignItems: "flex-start",
    width: "100%",
    ...shorthands.padding("12px"),
    "@media (min-width: 500px)": {
      flexDirection: "row",
      marginBottom: "8px",
    },
  },
  reviewLine: {
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    height: "35px",
    backgroundColor: tokens.colorNeutralBackground2,
    ...shorthands.padding("10px", "10px", "10px", "10px"),
    "@media (min-width: 500px)": {
      paddingLeft: "16px",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  taxAmount: {
    fontWeight: tokens.fontWeightRegular,
    textAlign: "right",
    "@media (max-width: 499px)": {
      ...shorthands.padding("9px", "16px", "9px", "0px"),
    },
    "@media (min-width: 500px)": {
      color: tokens.colorNeutralForeground3,
      ...shorthands.padding("9px", "18px", "9px", "0px"),
    },
  },
  totalAmount: {
    fontWeight: tokens.fontWeightBold,
  },
  loaderOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100px",
    height: "100px",
  },
});
